import type {
  MeasurementsCapabilityProvider,
  LineMeasurementType,
} from '@trimble/web3d-providers';
import { createBaseMeasurementController } from '@trimble/measurements-shared';
import type { LineMeasurementController } from './line-measurement.types';

export function createLineMeasurementController(
  provider: MeasurementsCapabilityProvider
): LineMeasurementController {
  return {
    type: 'line',
    ...createBaseMeasurementController<LineMeasurementType>(provider),
  };
}
